import { useState } from "react";
import { useNavigate } from "react-router-dom";
import clientsApi from "../../api/client/client";
import DataHandlerHelper from "../../helpers/DataHandler.helper";
import { localDayStartISO } from "../../helpers/dateFormat";
import { ui } from "../../helpers/ui";

const InitStopAllLogic = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<any>({
    fromDate: "",
    toDate: "",
  });

  const onSave = async () => {
    if (new Date(data.fromDate).toString() === "Invalid Date") {
      ui.alert("Neispravan datum Od");
      return;
    }
    if (new Date(data.toDate).toString() === "Invalid Date") {
      ui.alert("Neispravan datum Do");
      return;
    }
    const confirmed = await ui.confirm("Sigurno želite da sačuvate?");
    if (!confirmed) return;
    clientsApi
      .stopAll({
        fromDate: localDayStartISO(data.fromDate),
        toDate: localDayStartISO(data.toDate),
      })
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          ui.toast("Sačuvano", "success");
          navigate("/home");
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onChange = (event: any) => {
    setData(DataHandlerHelper.handleInputChange(event, { ...data }));
  };

  return {
    data,
    onSave,
    onChange,
  };
};

export default InitStopAllLogic;
